import { render, staticRenderFns } from "./QPolicyFinderResultsTable.vue?vue&type=template&id=fb20d3b4&"
import script from "./QPolicyFinderResultsTable.vue?vue&type=script&lang=js&"
export * from "./QPolicyFinderResultsTable.vue?vue&type=script&lang=js&"
import style0 from "./QPolicyFinderResultsTable.vue?vue&type=style&index=0&id=fb20d3b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports